module.exports = __webpack_public_path__ + "static/media/player-bg.10529865.gif";